module.exports = __webpack_public_path__ + "static/media/trywallet.725aaee7.png";